<script>
  import DatePick from 'vue-date-pick'
  import 'vue-date-pick/dist/vueDatePick.css'
  import moment from 'moment'

  export default {
    mixins: [DatePick],
    computed: {
      yearRange() {
        let nowYear = new Date().getFullYear(),
          years = [],
          currentYear = this.currentPeriod.year,
          startYear = currentYear - this.selectableYearRange,
          endYear = currentYear + this.selectableYearRange
        for (let i = startYear; i <= endYear; i++) {
          years.push(i)
          if (i == nowYear) break
        }
        return years.reverse()
      }
    },
    mounted() {
      let input = this.$el.querySelector('input')
      input.value = ''
      input.placeholder = moment().format(this.format)
    }
  }
</script>
